import { Link } from "react-router-dom";

const Veille = () => {
  function Veille(props) {
    return (
      <div className="veille">
        <img
          src={require("../../assets/img/veille/feedly-veille-0" +
            props.number +
            ".webp")}
          alt=""
        />
        <div className="veille-info">
          <h3>{props.title}</h3>
          <p className="veille-description">{props.desc}</p>
          <p className="veille-tag">{props.tag}</p>
        </div>
      </div>
    );
  }
  return (
    <section className="veille-section" id="veille">
      <h2>Veille</h2>
      <article>
        <Veille
          number="1"
          title="React"
          desc="Une veille orienté sur le frontend."
          tag="Feedly"
        ></Veille>
        <Veille
          number="2"
          title="PHP"
          desc="Une veille orienté sur le backend."
          tag="Feedly"
        ></Veille>
      </article>
      <div className="color-form blue"></div>
    </section>
  );
};

export default Veille;
